import { createReducer } from '@reduxjs/toolkit'
import {
  disconnectLink,
  updateConnected,
  updateFunds,
  updatePortfolio,
} from 'store/link/actions'
import { LinkState } from 'store/link/types'
import { connectLinkWalletAction } from './actions/connectLinkWalletActions'

const initialState: LinkState = {
  connected: false,
  connecting: false,
  chainId: '',
  signer: undefined,
  funds: {},
  portfolio: [],
}

export default createReducer<LinkState>(initialState, (builder) => {
  builder
    .addCase(updateConnected, (state, { payload }) => {
      state.connected = payload.connected
    })
    .addCase(updateFunds, (state, { payload }) => {
      state.funds = { ...state.funds, ...payload.funds }
    })
    .addCase(updatePortfolio, (state, { payload }) => {
      state.portfolio = [...payload.portfolio]
    })
    .addCase(disconnectLink, (state) => {
      state.signer = undefined
      state.chainId = ''
      state.connected = false
      state.connecting = false
    })
    .addCase(connectLinkWalletAction.pending, (state) => {
      state.connecting = true
    })
    .addCase(connectLinkWalletAction.rejected, (state) => {
      state.connecting = false
    })
    .addCase(connectLinkWalletAction.fulfilled, (state, { payload }) => {
      const { signer, chainId } = payload
      state.connecting = false
      state.connected = true
      state.signer = signer
      state.chainId = chainId
    })
})
